<app-header-new *ngIf="!isOnSignInPage"></app-header-new>
<!-- The scroll container. The header and footer stay pinned to the viewport and
     this region between them scrolls, so the scrollbar no longer runs past them
     and both span the full viewport width. Read the scroll position through
     AppScrollService, not `window`. -->
<main class="app-scroll">
    <router-outlet></router-outlet>
</main>
<app-footer-new *ngIf="!isOnSignInPage"></app-footer-new>
<app-allowance-warning-modal></app-allowance-warning-modal>
<!-- Session Expiry Modal -->
<!-- <div class="modal fade" [config]="{backdrop: 'static', keyboard: false}" bsModal #sessionExpiryModal="bs-modal"
    tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="sessionExpiryModal">Warning!</h5>
                <button type="button" class="btn-close" (click)="sessionExpiryModal.hide()"></button>
            </div>
            <div class="modal-body mb-2">
                <div>
                    {{confirmationData}}
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- This will be needed in future -->
<!-- <ngx-spinner bdColor="rgba(248,245,245,0)" type="ball-clip-rotate-multiple" color="#006736">
</ngx-spinner> -->
<ngx-spinner bdColor="rgba(248,245,245,0)" size="large" color="#ffffff" type="ball-spin" [fullScreen]="true"
    template="<img src='assets/images/loader-spinner.png' class='spinner-image' />">
</ngx-spinner>